module.exports = __webpack_public_path__ + "img/favorite.a6de7a4c.png";